import { atom } from 'jotai'

// 1️⃣ 定义初始状态
const initialAuthState = {
  authMenuList: [],
  isLoginModalVisible: false, // 新增：控制登录弹窗显示
}

// 2️⃣ 定义主 atom
export const authAtom = atom(initialAuthState)

// 3️⃣ 定义派生 atom：用于更新菜单列表
export const authMenuListAtom = atom(
  (get) => get(authAtom).authMenuList,
  (get, set, newMenuList: any) => {
    const prev = get(authAtom)
    set(authAtom, { ...prev, authMenuList: newMenuList })
  }
)

// 4️⃣ 新增：定义派生 atom，用于控制登录弹窗（拦截器将调用这个）
export const loginModalAtom = atom(
  (get) => get(authAtom).isLoginModalVisible,
  (get, set, visible: boolean) => {
    const prev = get(authAtom)
    // 如果当前状态已经是该值，则不重复设置，防止拦截器多次触发
    if (prev.isLoginModalVisible === visible) return
    set(authAtom, { ...prev, isLoginModalVisible: visible })
  }
)